import { type ComponentProps, type Ref } from "react";
import { TableHeader as BaseTableHeader } from "~/components/ui/table";
import { cn } from "~/utils";

export function TableHeader({
  ref,
  ...props
}: ComponentProps<typeof BaseTableHeader> & {
  ref?: Ref<HTMLTableSectionElement>;
}) {
  return (
    <BaseTableHeader
      ref={ref}
      {...props}
      className={cn("bg-secondary-50", props.className)}
    />
  );
}

TableHeader.displayName = "TableHeader";
